import { LocationQuery } from 'vue-router'
import CookieService from '~/services/cookies'
import Settings from '../services/settings'

export default defineNuxtRouteMiddleware(async (to) => {
	if (import.meta.server) return

	useNuxtApp()

	const hasParams = hasMetricsParams(to.query)
	const hasCookie = CookieService.getRegisterMetricsUrl()
	if (!hasParams || hasCookie) return
	const url = `${Settings.baseUrl()}${to.fullPath}`
	CookieService.setRegisterMetricsUrl(url)
})

function hasMetricsParams(query: LocationQuery) {
	return [
		query.ref,
		Object.keys(query).some((key) => key.startsWith('utm_')),
		Object.keys(query).some((key) => key in ['url_source', 'channel']),
	].some(Boolean)
}
